<template>
  <div id="home" @click="homeClick">

		<nav id="headNav">
			<div class="container">
				<!--logo-->
				<div id="logoBox" class="float-l">
					<img :src="userInfo.companyLogo" alt="公司logo" />
					<span>{{userInfo.companyShortName}}</span>
				</div>
				<!--菜单-->
				<div class="menuBox float-l">
	  				<Menu mode="horizontal" ref='topMenu' theme="dark" :active-name="actName" @on-select='menuChange'>
			  	 		<router-link to="/Home/Console">
				        	<MenuItem name="1" v-if='Menu1 || isAdmin'>控制台</MenuItem>
				        </router-link>

				        <MenuItem name="2" v-if='Menu2 || isAdmin'>现场监控</MenuItem>

				        <Submenu name="3" v-if='Menu3 || isAdmin'>
				            <template slot="title">大数据</template>
				            <MenuItem name="3_1" v-if='Menu3_1 || isAdmin'>用量液位分析</MenuItem>
                  <router-link to="/Hadoop/LiquidStatistics"><MenuItem name="3_5" v-if='Menu3_5 || isAdmin'>用量液位统计详情</MenuItem></router-link>
                  <router-link to="/Hadoop/levelStatis"><MenuItem name="3_8" v-if='Menu3_8 || isAdmin'>液位统计</MenuItem></router-link>
				            <router-link to="/Hadoop/OnlineRate"><MenuItem name="3_2" v-if='Menu3_2 || isAdmin'>在线率统计</MenuItem></router-link>
				            <router-link to="/Hadoop/ServeRate"><MenuItem name="3_3" v-if='Menu3_3 || isAdmin'>服务费统计</MenuItem></router-link>
				            <router-link to="/Hadoop/AccountNum"><MenuItem name="3_4" v-if='Menu3_4 || isAdmin'>账号统计</MenuItem></router-link>
				            <router-link to="/Hadoop/AbnormalStati"><MenuItem name="3_6" v-if='Menu3_6 || isAdmin'>异常统计</MenuItem></router-link>

				        <router-link to="/Hadoop/GasConsumption"><MenuItem name="3_7" v-if='Menu3_7 ||isAdmin'>用气量报表</MenuItem></router-link>
				        </Submenu>

				        <router-link to="/BigMap"  target="_blank">
				        	<MenuItem name="4" v-if='Menu4 || isAdmin'>大屏地图</MenuItem>
				        </router-link>

								<Submenu name="6" v-if='Menu6 || isAdmin'>
				            <template slot="title">审计管理</template>
				            <router-link to="/auditingManage"><MenuItem name="6_2" v-if='Menu6_2 || isAdmin'>登录审计</MenuItem></router-link>
				        </Submenu>
			    	</Menu>
	  			</div>
	  			<!--操作-->
	  			<div class="operaBox float-r">
	  				<!--搜索-->
	  				<div class="searchBox float-l" v-if="Menu2 || isAdmin">
		  				<Dropdown @on-click='dropMenu'>
					        <a href="javascript:void(0)">
					        	<Icon type="md-search" />
					           	{{searName}}
					            <Icon type="ios-arrow-down" />
					        </a>
					        <DropdownMenu slot="list">
					        	<DropdownItem name='站点' v-if='compantType==60'>站点</DropdownItem>
				            <DropdownItem name='车辆' v-if='compantType==60'>车辆</DropdownItem>
				            <DropdownItem name='用气点' v-if='compantType!=60'>用气点</DropdownItem>
					        </DropdownMenu>
					    	</Dropdown>

				    		<Select filterable clearable ref='searchSel' :label-in-value=true :placeholder='searPlac' remote @on-query-change="serachKeyUp" @on-change="seracChange">
		                <Option v-for="(item,index) in searchList" :value="index" :key="index">{{item.name}}</Option>
		            </Select>
		            </div>

		            <!--用户报警信息，服务跳转-->
		            <div class="userBox float-l">
		            	<Dropdown @on-click='terraceClick' >
						        <a href="javascript:void(0)">
						        	<Icon type="md-apps" />
						        </a>
						        <DropdownMenu slot="list" v-show="isAdmin" >
					      	  	<DropdownItem name='0'>
												<Icon type="md-cloud-circle" size='24'color='#379efd'/>&nbsp;基础服务</DropdownItem>
						        </DropdownMenu>
						</Dropdown>

		            	<div class="alarmBox" >
		            		<div class="alarm" @click='BadgeClick'>
			            		<Badge :count="infoNum" overflow-count="99">
							        <a href="javascript:void(0)" >
							        	<Icon type="md-notifications-outline" size='36'/>
							        </a>
							    		</Badge>
		            		</div>

						    <div class="tabBox" id="alarmOinfo" v-if="tabShow">
						    	<Card style="width:330px">
								    <Tabs :value="tabVal" :animated="false">
								        <TabPane :label="noticeNum" name="0">
								        	<template v-for='item in noticData'>
									        	<div class="infoList">
									        		<div class="list-head float-l"><div class="dot"></div></div>
									        		<div class="list-body float-l">
									        			<div class="title">
									        				<div class="title-bar low " v-if="item.level==10">普通</div>
									        				<div class="title-bar hig" v-if="item.level==20">紧急</div>
									        				{{item.title}}
									        			</div>
									        			<div class="infomian">
									        				{{item.description.toLonging(28)}}
									        			</div>
									        		</div>
									        	</div>
								        	</template>

								        	<router-link to="/SceneMonit/Inform">
								        		<div class="tabFoot" @click="tabShow=false">更多信息</div>
								        	</router-link>
								        </TabPane>
								        <TabPane :label="alarmNum" name="1" v-show='alarm || isAdmin' v-if="$store.getters.checkMenus('MO_ALARM')">
								        	<template v-for='item in alarmData'>
									        	<div class="infoList">
									        		<div class="list-head float-l">
									        			<div class="dot"></div>
									        		</div>
									        		<!--数据异常,断线报警-->
									        		<div class="list-body float-l" v-if="item.alarmType==1">
									        			<div class="title">
									        				<div class="title-bar hig" v-if="item.alarmLevel==30">高</div>
									        				<div class="title-bar mi" v-if="item.alarmLevel==20">中</div>
									        				<div class="title-bar low" v-if="item.alarmLevel==10">低</div>
									        				{{item.alarmName}} {{item.alarmEndValue}} {{item.operator}} {{item.alarmRuleValue}}
									        			</div>
									        			<div class="infomian" :title="item.shortName+'-'+item.siteName+'-'+item.collectParamterName+' '+item.alarmStartTime.moreTime()">
									        				{{item.shortName}} - {{item.siteName}} <span v-if='item.collectParamterName'>-</span>{{item.collectParamterName}} {{item.alarmStartTime.moreTime()}}
									        			</div>
									        		</div>
									        		<!--流量计故障，线路异常-->
									        		<div class="list-body float-l"  v-if="item.alarmType==2 || item.alarmType==3">
									        			<div class="title">
									        				<div class="title-bar hig" v-if="item.alarmLevel==30">高</div>
									        				<div class="title-bar mi" v-if="item.alarmLevel==20">中</div>
									        				<div class="title-bar low" v-if="item.alarmLevel==10">低</div>
									        				{{item.alarmName}}
									        			</div>
									        			<div class="infomian" :title="item.shortName+'-'+item.siteName+'-'+item.name+' '+item.alarmStartTime.moreTime()">
									        				{{item.shortName}} - {{item.siteName}} <span v-if='item.name'>-</span>{{item.name}} {{item.alarmStartTime.moreTime()}}
									        			</div>
									        		</div>

									        	</div>
								        	</template>
								        	<router-link to="/SceneMonit/Alarm">
								        		<div class="tabFoot" @click="tabShow=false">更多信息</div>
								       		</router-link>
								        </TabPane>
								    </Tabs>
							    </Card>
						    </div>
		            	</div>

						<div class="userOper">

							<Dropdown @on-click='userDropMenu'>
								<a href="javascript:void(0)">
						        	<Avatar icon="md-person" />
									<span>{{userInfo.username|reserveStr(4)}}</span>
					       		</a>
						        <DropdownMenu slot="list">
						        		<DropdownItem name='0'><Icon type="ios-paper" size='18'/> 修改密码</DropdownItem>
						            <DropdownItem name='1'><Icon type="ios-cog" size='20'/> 设置个人信息</DropdownItem>
									      <DropdownItem name='2'><Icon type="ios-phone-portrait" size='20'/> 手机解绑</DropdownItem>
						            <DropdownItem divided name='3'> <Icon type="md-log-out" size='17'/> 退出登录</DropdownItem>
						        </DropdownMenu>
					   		</Dropdown>
						</div>

		            </div>
	  			</div>
			</div>
		</nav>

		<div id="rouBoxOne" class="container">
			<!-- <audio src="../../static/audio/bell.mp3"  controls="controls" id="audios" hidden ></audio> -->
			<audio id="audios" hidden controls="controls">
			<source src="../../static/audio/bell.mp3"  >
			</audio>
			<router-view></router-view>

			<router-link to="/Home/Toolkit">
				<div class="toolBox" v-if="Menu5 || isAdmin">
					<Icon type="ios-briefcase" size="46" color='#80848f'/>
					<p>工具箱</p>
				</div>

	    </router-link>
		<div class="GasCart " @click="modal1 = true,gasnum=-1" v-show="isShowGas">
			    <Badge :count="Gastotal" overflow-count="99" type="primary">
					<img src="../../static/image/zyd.gif" >
			    </Badge>

		</div>
		<!-- 购气宝列表 -->
		<Modal v-model="modal1"  width='420'>
	   <p slot="header" style="font-size:18px;text-align:center">
            资源单
        </p>
        <ul class="GasList">
			<li  v-for="(item,index) in GasList" style="background:#f8f8f9;">
				<div class="GasInfo"><h5>{{item.lngResource.lngSource}}</h5><div>{{item.publishTime|dateLong}}</div></div>
                <div class="GasInfo" @click="showDetail(index)"  style="background:#e8eaec;cursor:pointer;">
				<span class="GasCoust">{{item.company?item.company+'-':''}}{{item.lngResource.contactsUser}}<br>
				供应范围：<b v-for="list in item.lngResource.supplyArea"> {{item.lngResource.supplyArea.length>0?list.name:''}} </b></span>
				<b style="font-size:18px;margin-top:8px; color:#ff7220;">  {{item.lngResource.supplyAmount+item.lngResource.unit}}</b>
				</div>
				<!-- 资源 -->
				<div class="detailGas" v-show="index==gasnum">
					<p  style="font-size:18px;text-align:center;color:#ff7220;border-bottom: 2px solid #dcdee2;">
					  <b>询价</b>
					</p>
					<div class="infoItem">
	         			<span>联系人：</span><b class="rightItem">{{item.lngResource.contactsUser}}</b>
	         		</div>
				    <div class="infoItem">
	         			<span>联系电话：</span><b class="rightItem" style=" color:#2d8cf0;">{{item.lngResource.phone}}</b>
	         		</div>
					 <div class="infoItem">
	         			<span>供应量：</span><b class="rightItem" style=" color:#ff7220;">{{item.lngResource.supplyAmount+item.lngResource.unit}}</b>
	         		</div>
					 <div class="infoItem">
	         			<span>发布时间：</span><b class="rightItem">{{item.publishTime}}</b>
	         		</div>
				</div>
			</li>

		</ul>
		<div slot="footer">
            <Button type="primary" size="large"   @click="lookMore">查看更多</Button>
        </div>
    </Modal>
	<Modal
		v-model="isGO" width='330'
		title="扫一扫，即可获取更多资源单信息">
		<img src="../../static/image/resources.png" style="margin-left:15px;">

		<div slot="footer">
		</div>
	</Modal>
	  </div>

    <footer>
    	<p class="footP">Copyright&copy;2017 ZNDL - by 中能鼎立旗下品牌中能智为 全国热线：400-828-9220
    		<a href="http://www.cnzz.com/stat/website.php?web_id=1274821032" target="_blank" title="站长统计"><img border="0" hspace="0" vspace="0" src="http://icon.cnzz.com/img/pic1.gif"></a>
    	</p>
    </footer>

    <BackTop></BackTop>

    <!--修改密码弹框-->
    <Modal v-model="myPsw" title="修改密码" :mask-closable="false" :closable="fromForbid" >
      <div class="modal-body shortModal" >
      	<Form ref="pswForm" :model="pswForm" :rules="passRule" :label-width="100">
      		<FormItem label="请输入原密码" prop="password">
	            <Input v-model="pswForm.password" size="large" type="password" placeholder="请输入原密码"></Input>
	        </FormItem>
	        <FormItem label="请输入新密码" prop="newPsw">
	            <Input v-model="pswForm.newPsw" size="large" type="password" placeholder="请输入新密码"></Input>
	        </FormItem>
	        <FormItem label="确认新密码" prop="veriPsw">
	            <Input v-model="pswForm.veriPsw" size="large" type="password" placeholder="请再次输入新密码"></Input>
	        </FormItem>
      	</Form>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" :loading="modal_loading" @click="savePass">保存</Button>
    		<Button  size="large" @click="myPsw=false"	 v-if="fromForbid">取消</Button>
      </div>
		</Modal>

		 <!--修改个人信息-->
    <Modal v-model="myInfo" title="修改个人信息" :mask-closable="false">
      <div class="modal-body shortModal">
      	<Form ref="infoForm" :model="infoForm" :rules="ruleValidate" :label-width="80">
      		<FormItem label="姓名" prop="name">
	            <Input v-model="infoForm.name" size="large" placeholder="请输入姓名"></Input>
	        </FormItem>
	        <FormItem label="手机号" prop='phone'>
	            <Input v-model="infoForm.phone" size="large" placeholder="请输入手机号"></Input>
	        </FormItem>
	        <FormItem label="邮箱" prop='mail'>
	            <Input v-model="infoForm.mail" size="large" placeholder="请输入邮箱"></Input>
	        </FormItem>
	         <FormItem label="性别">
	            <RadioGroup v-model="infoForm.radio">
                <Radio label="1">男</Radio>
                <Radio label="0">女</Radio>
            </RadioGroup>
	        </FormItem>
      	</Form>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" :loading="modal_loading" @click="saveUserInfo">保存</Button>
    		<Button  size="large" @click="myInfo=false">取消</Button>
      </div>
		</Modal>

		<Modal v-model="myPwdType" title="提示" :mask-closable="false" :closable="false">
			<div>
				<p>{{tip}}</p>
			</div>
			<div slot="footer">
				<Button type="primary" @click="getPwdModal">修改密码</Button>
			</div>
			<!-- <template #footer>
				<Button type="primary" @click="getPwdModal">修改密码</Button>
				<Button type="primary" @click="getGuModal">取消</Button>
			</template> -->
		</Modal>

		<Modal v-model="myConfirm" title="取消密码修改" :mask-closable="false">
			<div>
				<p>确认取消修改密码吗？</p>
			</div>
			<template #footer>
				<Button type="primary" @click="confirmGu">确认</Button>
				<Button type="primary" @click="backLastModyfy">返回</Button>
			</template>
		</Modal>
  </div>

</template>
<script>
	import RULE from '../../static/js/rule.js'
	import {beforeTime} from '../common/index'
	import {timeDiff} from '../common/index'
	import {lookHisData} from '../common/index'
  import {getPwdType} from '@/api/Map.js'
  export default {
    name: "home",
    data() {
			const validatePass = (rule, value, callback) => {
			    if (value === '') {
			        callback(new Error('请输入新的密码'));
			    } else {
			        if (this.pswForm.veriPsw !== '') {
			            // 对第二个密码框单独验证
			            this.$refs.pswForm.validateField('veriPsw');
			        }
			        callback();
			    }
			};

			const validatePassCheck = (rule, value, callback) => {
        let reg = /^(?=.*?[A-Z])(?=(.*[a-z])+)(?=(.*[\d])+)(?=(.*[\W])+)(?!.*\s).{8,20}$/;
        console.log(reg.test(value),1234)
			    if (value === '') {
			        callback(new Error('请再次输入你的密码！'));
			    } else if (value !== this.pswForm.newPsw) {
			        callback(new Error('两次输入密码不一致！'));
			    }else if(!reg.test(value)){
            callback(new Error('新密码长度为8-20位，且必须包含数字、大小写字母、特殊字符！'));
          } else {
			        callback();
			    }
			};
      return {
		  isShowGas:0,
		  gasnum:4,
		  isGO:false,
		  modal1:false,
      	userInfo:{},
      	compantType:'',
      	companyId:'',
      	userId:'',
				actName:'',
				Menu1:false,
				Menu2:false,
				Menu3:false,
				Menu3_1:false,
				Menu3_2:false,
				Menu3_3:false,
				Menu3_4:false,
        Menu3_5:false,
        Menu3_8:false,
				Menu3_6:false,
				Menu3_7:false,
				Menu4:false,
				Menu5:false,
				Menu6:false,
				Menu6_1:false,
				Menu6_2:false,
				alarm:false,
				isAdmin:false,
				searName:'站点',
				searPlac:'请输入站点名称',
				searchList:[],
				tabShow:false,
				tabVal:'0',
				noticeNum:"通知（0）",
				alarmNum:"报警（0）",
				infoNum:0,
				Gastotal:0,
				alarmList:[],
				noticeList:[],
				GasList:[],
				ruleValidate:RULE.ruleValidate,
				myPsw:false,
				myPwdType:false,
				myConfirm:false,
				tip:'',
				pswForm:{
					password:'',
					newPsw:'',
					veriPsw:''
				},
				passRule: {
            newPsw: [
	            {required:true,validator:validatePass,trigger:'blur'},
							{type:'string',min:8,message:'密码不能少于8位',trigger: 'blur' },
							{type:'string',max:20,message:'密码不能大于20位',trigger: 'blur' }
            ],
            veriPsw: [
	            {required:true,validator:validatePassCheck,trigger:'blur'},
            ],
            password: [
	            {required:true,message:'密码不能为空',trigger:'blur'},
	            {type:'string',min:6,message:'密码不能少于6位',trigger: 'blur' }
		        ],
        },
				modal_loading:false,
				//
				myInfo:false,
				infoForm:{
					name:'',
					phone:'',
					mail:'',
					radio:'1'
				},
				noticData:[],
				alarmData:[],
				alarmNotic:false,
				footLink:'',
				fromForbid:true
      }
    },
    created: function () {//实例被创建之后执行代码
			String.prototype.moreTime = function () {
				return beforeTime(this.substring(0, 19));
			};
			String.prototype.toLonging = function (num) {
			  return this.length<num?this:this.substring(0,num)+'...';
			};
    },
    computed: {//计算属性
			newMenu(){
				return this.$store.state.newMenu;
			}
    },
    components: {//组件的引用

    },
		methods: {//方法
			checkPwd(){
        getPwdType(null,res=>{
          //let pwdType = JSON.parse(localStorage.getItem("userInfo"))['pwdType'];
          let pwdType = res.data.body;
          let tips = ["您的密码已超过3个月未更换，为了账户安全，请修改密码","您的密码过于简单，为了账户安全，请修改密码","为了您的账户安全，请修改初始密码"];
          if(pwdType!='') {
            this.myPwdType = true;
            this.fromForbid = false;
            this.tip = tips[pwdType-1];
          }
        })

			},

			getPwdModal(){
				this.myPwdType = false;
				this.myPsw = true;
			},

			getGuModal(){
				this.myPwdType = false;
				this.myConfirm = true;
			},

			confirmGu(){
				this.myConfirm = false;
			},

			backLastModyfy() {
				this.myConfirm = false;
				this.myPwdType = true;
			},

         //购气宝购物车
			lookMore(){
			 this.modal1=false;
			 this.isGO=true;
			},
			showDetail(index){
              this.gasnum=index;
			},
			getShowGas(){//获取资源单权限
              this.$http.get('/mws/account/'+this.$store.state.userId+'/isHaveFireWall').then(response => {
               this.isShowGas=Number(response.data.body);

             });
			},
      // ,
			// getGas(){//获取资源单信息列表
      //         this.$http.get('https://api.golng.cn:5678/golng-res/supplylnglist?type=1&date=0&pageNum=1&pageSize=3').then(response => {
      //          this.GasList=response.data.body.list;
      //             this.Gastotal=response.data.body.total
			// 	}, response => {
			// 		console.log("error");
			// 	});
      //
			// },
    	//主菜单点击事件
			menuChange:function(name){
				this.$store.state.newMenu = name;
				sessionStorage.setItem('newMenu',name);

				let conpanyType = JSON.parse(localStorage.getItem('userInfo')).companyCategory;

				if(name == '3_1' && conpanyType=='60'){
					this.$router.push('/Hadoop/LiquidLevel');
				}else if(name == '3_1' && (conpanyType=='70'||conpanyType=='50')){
					this.$router.push('/Hadoop/LiquidLevelTwo');
				};

				if(name == '2' && conpanyType=='60'){
					this.$router.push('/Home/SceneMonit');
				}else if(name == '2' && conpanyType != '60' ){
					this.$router.push('/SceneMonit/SiteParti/Circuit');
				};
			},
			getActName(){    //设置当前选中菜单
			let userInfo = localStorage.getItem('userInfo')==null?'':JSON.parse(localStorage.getItem('userInfo'));
			if (userInfo.companyCategory!=60) {
								this.actName = '2';
								}
				if(sessionStorage.getItem('newMenu')==null){

					this.actName = '1';
				}else{
					this.actName = sessionStorage.getItem('newMenu');
				};
			},
			//搜索下拉菜单点击事件
			dropMenu(name){
				this.searName = name;
				this.searPlac = "请输入"+name+"名称";

				this.$refs.searchSel.clearSingleSelect();
				this.searchList = [];
			},
			BadgeClick(){		 //通知报警点击
				this.tabShow = !this.tabShow;
				if(this.noticData.length==0){
					this.getNoticeData();
				}
			},
			setShowMenu(){  //设置显示菜单
					if(this.userInfo.admin==1 && this.userInfo.companyId==1){
						this.isAdmin=true;
						this.tabVal = '1';
						this.getAlarmData();
						this.getAlarmInfo();
						return;

					}
					let menus = this.userInfo.menus.split(',');

					for (var i=0;i<menus.length;i++) {
						switch (menus[i]){
							case 'CONSOLE':
							  this.Menu1=true;
							  this.actName = '1';
								break;
							case 'MONITOR':
								this.Menu2=true;
								break;
							case 'BIGDATA':
								this.Menu3=true;
								break;
							case 'BD_LLS':case 'BD_USER_LLS':
								this.Menu3_1=true;
								break;
							case 'BD_ONLINE':
								this.Menu3_2=true;
								break;
							case 'BD_MONEY':
								this.Menu3_3=true;
								break;
							case 'BD_ACCOUNT':
								this.Menu3_4=true;
								break;
							case 'BD_LLS_DETAIL':
								this.Menu3_5=true;
							break;
              case 'BD_LLS_RESULT':
                this.Menu3_8=true;
                break;
							case 'BD_ALARM':
								this.Menu3_6=true;
							break;
							case 'BD_USE_REPORT':
								this.Menu3_7=true;
							break;
							case 'BIGMAP':
								this.Menu4=true;
								break;
							case 'TOOLBOX':
								this.Menu5=true;
								break;
							case 'AUDIT':
								this.Menu6=true;
								break;
							case 'LOGIN_AUDIT':
								this.Menu6_1=true;
								break;
							case 'LOGIN_AUDIT:LIST':
								this.Menu6_2=true;
								break;
							case 'MO_ALARM':
							  this.alarm = true;
							  this.tabVal = '1';
							  this.getAlarmData();
							  this.getAlarmInfo();
							  break;
						}
					};
			},
			//用户操作
			userDropMenu(name){
				switch(name){
					case '0':
					  this.$refs['pswForm'].resetFields();
						this.myPsw = true;
						this.fromForbid = true;
					  break;
					case '1':
						this.$refs['infoForm'].resetFields();
						this.getUserInfo();
					  this.myInfo = true;
					  break;
					case '2':
					  this.confirm();

					  break;
					case '3':
					  this.outLogin();
					  break;
				}
			},
			confirm () {  //手机解绑
				let that = this;
        this.$Modal.confirm({
	        title: '解绑确定',
	        content: '<p>你确定要解绑手机吗？</p>',
	        onOk: () => {
	        	let phoneData = {
	        		"id":that.userId,
	        	};
	         this.$http.put('/ucms/user/unbindPhone',phoneData).then(ret=>{
	         		if(ret.data.errcode==0){
								this.$Message.success('手机解绑成功！');
							}else{
								this.$Message.error('手机解绑失败!');
							}
	         })
	        },
        });
   		},
			//退出登录
			outLogin(){
				this.$Notice.destroy();
				this.$http.delete('/ucms/user/logout').then(ret=>{
					if(ret.data.errcode == 0){
						this.$Message.info('退出成功！');
					}else{
						this.$Message.info('退出失败！');
					}
					sessionStorage.clear();
					localStorage.removeItem('userInfo');
					this.$router.push('/');
				});
			},
			getLogoUser(){  //获取登录用户信息
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
				if(this.userInfo.companyLogo==''){
					this.userInfo.companyLogo='../../static/image/logo.png';
				};
				this.userId = this.userInfo.id;
    		this.companyId = this.userInfo.companyId;
				this.compantType = this.userInfo.companyCategory;
				if(this.compantType!=60){
					this.searName = '用气点';
					this.searPlac = "请输入用气点名称";
				}
			},
			//搜素键盘事件
			serachKeyUp(query){
				let type = '';
				switch(this.searName){
					case "站点":
						type = 1;
						break;
					case "车辆":
						type = 2;
						break;
					case "用气点":
						type = 3;
						break;
				};
				this.searchList = [];
				let url = encodeURI('/mws/site/search?sType='+type+'&sName='+query);
				this.$http.get(url).then(ret=>{
					if(ret.data.errcode==0){
						this.searchList = ret.data.body;
					};
				});
			},
			seracChange(val){  //搜索显示
				if(val == undefined)return;

				let type = '',hisArr = [],myUrl ='';

				sessionStorage.setItem('siteParti',this.searchList[val.value].id);
				this.$store.state.siteParti = this.searchList[val.value].id;

				this.actName='2';
				sessionStorage.setItem('newMenu','2');

				switch(this.searName){
					case "站点":
						type = 1;
						myUrl = '/SceneMonit/SiteParti/Scene';
						break;
					case "车辆":
						type = 0;
						myUrl = '/SceneMonit/Car?d='+this.searchList[val.value].id+'&c='+this.searchList[val.value].companyId+','+this.searchList[val.value].groupId;
						break;
					case "用气点":
						type = 3;
						myUrl ='/SceneMonit/SiteParti/Circuit';
						break;
				};

				//用气点没有历史记录功能
				if(this.searName!='3'){
					hisArr[0] = this.searchList[val.value].id;
					hisArr[1] = type;
					hisArr[2] = this.searchList[val.value].name;
					hisArr[3] = this.searchList[val.value].companyId+','+this.searchList[val.value].groupId;
					lookHisData(hisArr.join(','));
				};

				this.$router.push(myUrl);
				this.$refs.searchSel.clearSingleSelect();
				this.searchList = [];
			},
			savePass(){        //修改密码
				this.modal_loading=true;
				var passData = {
					"id":this.userId,
					"oldPassword":this.pswForm.password,
					"newPassword":this.pswForm.newPsw
				};

				this.$refs['pswForm'].validate((valid) => {
	        if (!valid) {
	        	this.modal_loading=false;
	          // this.$Message.error('请正确填写信息!');
	        }else{
	        	this.$http.put('/ucms/user/pwd',passData).then(ret=>{
						this.modal_loading=false;
						if(ret.data.errcode==0){
								this.myPsw = false;
								this.$Message.success('密码修改成功！');
								this.checkPwd()
							}else if(ret.data.errcode == 81021){
								this.$Message.info('旧密码不匹配!');
							}else if(ret.data.errcode == 81025){
								this.$Message.info('新密码长度为8-20位，且必须包含数字、大小写字母、特殊字符!');

							}else{
								this.$Message.info('密码修改失败！请稍后重试');
							}
						});
	        }
        });
			},
			saveUserInfo(){     //保存用户信息
				this.modal_loading = true;
				let userData = {
					"id":this.userId,
					"name":this.infoForm.name,
					"sex":this.infoForm.radio,
					"phone":this.infoForm.phone,
					"email":this.infoForm.mail
				};
				 this.$refs['infoForm'].validate((valid) => {
	        if (!valid) {
	        	this.modal_loading = false;
	        	this.$Message.error('请正确填写信息!');
	        	this.userName = this.infoForm.name;
	        	sessionStorage.setItem('username',myDat.username);
	        }else{
        		this.$http.put('/ucms/user',userData).then(ret=>{
							if(ret.data.errcode==0){
								this.modal_loading=false;
								this.myInfo = false;
								this.$Message.success('保存成功！');
							}else{
								this.modal_loading=false;
								this.$Message.error('保存失败！');
							}
						});
	        }
				 });
			},
			terraceClick(name){  //平台跳转
				let token = localStorage.getItem('token');
				if(token!=''){
				 	switch (name){
				 		case '0':
				 			window.open(this.$BaseHref);
				 			break;
				 	}
				}
			},
			getAlarm(){  //获取报警通知数
				this.$http.get('/mws/alarm/alarmNum').then(ret=>{
					if(ret.data.errcode==0){

					  this.alarmNum = "报警（"+ret.data.body.alarmNum+"）",
						this.noticeNum ="通知（"+ret.data.body.noticeNum+"）";
						this.infoNum = ret.data.body.alarmNum + ret.data.body.noticeNum;
						if (this.$store.getters.checkMenus('MO_ALARM')) {
						   this.infoNum = ret.data.body.alarmNum + ret.data.body.noticeNum;
						} else {
							this.infoNum=ret.data.body.noticeNum;
						}

						if (!ret.data.body.alarmNum) {
							return
						} else {

							let _audio = document.getElementById('audios');//获取audio元素
							_audio.setAttribute("autoplay", "autoplay");

						}
					}
				})
			},
			getNoticeData(){   //获取通知信息
				this.$http.get('/mws/notice?pageNum=5&userId='+this.userId).then(ret=>{
					if(ret.data.errcode == 0){
						this.noticData = ret.data.body;
					}
				});
			},
			getAlarmData(){   //获取报警信息
				this.$http.get('/mws/alarm/rank?pageNumber=5').then(ret=>{
					if(ret.data.errcode == 0){
						this.alarmData = ret.data.body;
					}
				});
			},
			getAlarmInfo(){   //报警信息提示
				if(this.alarmNotic) return;
				let that = this;
				this.$http.get('/mws/alarm/urgent?companyId='+this.companyId)
					.then(ret => {
						this.alarmNotic = true;
						if(ret.data.errcode==0){

							if(ret.data.body.length==0)return;
							let myData = ret.data.body;

							myData.forEach(function(item,list){
								let html = `<p>${item.shortName}-${item.siteName}</p><p>持续时间: ${timeDiff(item.alarmStartTime,item.alarmEndTime,'s')}</p>
									<p>开始时间: ${item.alarmStartTime}</p><p>截止时间: ${item.alarmEndTime}</p>`;

								that.$Notice.warning({
			            title: item.alarmName,
			            desc: html,
			            duration:0,
//			            name:'name'+list,
			            onClose:function(){
										let putData = {
											'userId':that.userId,
											'alarmId':item.alarmId,
										};
										this.$http.put('/mws/alarm',putData).then(ret=>{
											if(ret.data.errcode==0){
												that.$Message.info(ret.data.body);
											}else{
												that.$Message.info(ret.data.body);
												return;
											}
										});
			            }
			        	});
							})

		        }
					});
			},
			homeClick(event){      //home点击事件 ，用于点击空白处关闭下拉框等，例如报警框
				let sp = document.getElementById("alarmOinfo");
				if(sp){
					if(!sp.contains(event.target)){            //这句是说如果我们点击到了id为myPanel以外的区域
						this.tabShow = false;
					}
				}
			},
			getUserInfo(){     //获取当前用户信息
				this.$http.get('/ucms/user/'+this.userId).then(ret=>{
					if(ret.data.errcode == 0){
						let myDat = ret.data.body;
						this.infoForm.name = myDat.username;
						this.infoForm.phone = myDat.phone;
						this.infoForm.mail = myDat.email;
						this.infoForm.radio = myDat.sex;
					}
				});
			},

    },
	mounted(){  //页面进入时加载内容
	//this.checkPwd();
	//   this.getGas();
	   this.getShowGas();
    	this.getLogoUser();
    	this.setShowMenu();

			this.getAlarm();
			this.homeClick();

			this.getActName();
			this.$nextTick(function() {
				this.$refs.topMenu.updateActiveName();
			});


    },
    watch:{			//监测变化
      newMenu:{
      	handler:function(val){
      		sessionStorage.setItem('newMenu',val);
      		this.actName = val;

      	}
      }
    }
  }

</script>
<style lang="scss" >
@import "../../static/css/home.scss";
.toolBox{
	margin-left: 16px;
}

.toolBox p,.GasCart p{
	color: #80848f;
	text-align: center;
}
.GasList li{
          border: 1px solid #dcdee2;
		  border-radius: 5px;
		  font-size: 14px;
		  margin-bottom: 15px;
		  position: relative;
	  }
.GasList  .GasInfo{
	  padding: 5px 10px 5px 5px;
	  display: flex;
	 justify-content: space-between;
	 }
 .GasInfo:nth-of-type(1){
	 border-bottom: 1px solid #dcdee2;
	 vertical-align: bottom;
 }
.GasInfo h5{
	font-size: 18px;
}
.detailGas{
	position: absolute;
	top: 0;
	right: -340px;
	width: 300px;
	z-index: 1000000;
	background: #fff;
	padding: 10px;
	border: 1px solid #dcdee2;
	border-radius: 5px;
}
.infoItem{
	/*height:32px;*/
	min-height:32px;
	line-height:32px;
	font-size:15px;
	color:#5E5E5E;
}
.infoItem span{
	margin-left:10px;
	display: inline-block;
	width: 90px
}
</style>
